/**
 * An Entity type
 */
export enum EntityType {
  CONTACT = 'contact',
  COMPANY = 'company',
  OTHER = 'other',
  USER = 'user',
}

export enum UserState {
  SIGNEDUP = 'signed-up',
  PENDING = 'invited',
}
